'use strict';

export function InitThumbnails(thumbnails, limit = 9) {
	const thumbnailCount = thumbnails.length;

	// Hide all thumbnails above the limit
	for (let index = limit; index < thumbnailCount; ++index) {
		const thumbnail = thumbnails[index];

		thumbnail.style.display = 'none';
		thumbnail.style.opacity = '0';
	}
}

export function showThumbnails (thumbnails, offset = 0, limit = 0) {
	const thumbnailCount = thumbnails.length;

	for (let index = offset; index < thumbnailCount; ++index) {
		const thumbnail = thumbnails[index];

		if (thumbnail.style.display === 'none') showThumbnail(thumbnail);
	}
}

function showThumbnail(thumbnail) {
	thumbnail.style.removeProperty('display');

	setTimeout(() => {
		thumbnail.style.opacity = '1';
	}, 10);
}
